import React, { useEffect, useState } from 'react';

const easeOut = (t) => 1 - Math.pow(1 - t, 3); // Cubic ease-out function

const AnimatedStat = ({ start, end, duration = 2000, decimalPlaces = 2, onAnimationComplete }) => {
    const [value, setValue] = useState(start);
    const [hasAnimated, setHasAnimated] = useState(false);

    useEffect(() => {
        if (hasAnimated) return; // Prevent re-triggering after animation completes

        const startTime = performance.now();
        let animationFrameId;

        const updateValue = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = easeOut(progress);

            const currentValue = start + (end - start) * easedProgress;
            const displayValue =
              currentValue % 1 === 0
                ? currentValue
                : currentValue.toFixed(decimalPlaces);

            setValue(displayValue);

            if (progress < 1) {
                animationFrameId = requestAnimationFrame(updateValue);
            } else {
                setHasAnimated(true); // Set animation as completed
                if (onAnimationComplete) onAnimationComplete();
            }
        };

        animationFrameId = requestAnimationFrame(updateValue);

        return () => cancelAnimationFrame(animationFrameId);
    }, [start, end, duration, decimalPlaces, onAnimationComplete, hasAnimated]);

    return <span>{value}%</span>;
};

// Wrapper component to handle animation completion and display the change
const StatWrapper = ({ start, end, duration, change }) => {
    const [isCompleted, setIsCompleted] = useState(false);

    useEffect(() => {
        setIsCompleted(false);
    }, [start, end]);

    return (
      <div className="stat-value-container">
          <AnimatedStat
            start={start}
            end={end}
            duration={duration}
            onAnimationComplete={() => setIsCompleted(true)}
          />
          { change !== 0 && (<div
            className="stat-change-container"
            style={{
                opacity: isCompleted ? 1 : 0,
                transition: 'opacity 0.5s ease-in-out'
            }}
          >
              {isCompleted && (
                <span className="stat-change">{change}%</span>
              )}
          </div>)}
      </div>
    );
};

export default StatWrapper;